var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useMemo, useState } from "react";
import { List, DateField, FunctionField, TextField, DatagridConfigurable, SelectInput, TextInput, useListContext, useNotify, useRefresh, useSidebarState, useGetOne, } from "react-admin";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useTranslation } from "react-i18next";
import { Visibility } from "@mui/icons-material";
import { ActionsColumn } from "@/components/ActionButons";
import { ListActions } from "@/components/ListActions";
import { StatusApplicationChip } from "@/components/StatusApplicationChip";
import { Dialog } from "@sequentech/ui-essentials";
import { FormStyles } from "@/components/styles/FormStyles";
import { DownloadDocument } from "../User/DownloadDocument";
import { useMutation } from "@apollo/client";
import { EXPORT_APPLICATION } from "@/queries/ExportApplication";
import { IPermissions } from "@/types/keycloak";
import { ETasksExecution } from "@/types/tasksExecution";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ImportDataDrawer } from "@/components/election-event/import-data/ImportDataDrawer";
import { IMPORT_APPLICATION } from "@/queries/ImportApplication";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useQuery } from "@apollo/client";
import { USER_PROFILE_ATTRIBUTES } from "@/queries/GetUserProfileAttributes";
import { styled } from "@mui/material/styles";
import { Chip, CircularProgress } from "@mui/material";
import { convertToCamelCase } from "./UtilsApprovals";
import { getAttributeLabel, getTranslationLabel } from "@/services/UserService";
import { useLocation } from "react-router-dom";
import { getPreferenceKey } from "@/lib/helpers";
import CustomDateField from "../User/CustomDateField";
var StyledChip = styled(Chip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 4px;\n"], ["\n    margin: 4px;\n"])));
var StyledNull = styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: block;\n    padding-left: 18px;\n"], ["\n    display: block;\n    padding-left: 18px;\n"])));
// Storage key for the status filter
var STATUS_FILTER_KEY = "approvals_status_filter";
var ApprovalsList = function (props) {
    var _a;
    var _b = useListContext(), filterValues = _b.filterValues, setFilters = _b.setFilters, data = _b.data;
    var location = useLocation();
    var t = useTranslation().t;
    var isOpenSidebar = useSidebarState()[0];
    var userBasicInfo = ["first_name", "last_name", "email", "username", "dateOfBirth"];
    var listFields = useMemo(function () {
        var _a;
        var basicInfoFields = [];
        var attributesFields = [];
        var omitFields = [];
        (_a = props.userAttributes) === null || _a === void 0 ? void 0 : _a.get_user_profile_attributes.forEach(function (attr) {
            var _a;
            if (attr.name && userBasicInfo.includes(attr.name)) {
                basicInfoFields.push(attr);
            }
            else {
                omitFields.push("applicant_data[".concat(convertToCamelCase(getAttributeLabel((_a = attr.name) !== null && _a !== void 0 ? _a : "")), "]"));
                attributesFields.push(attr);
            }
        });
        return { basicInfoFields: basicInfoFields, attributesFields: attributesFields, omitFields: omitFields };
    }, [(_a = props.userAttributes) === null || _a === void 0 ? void 0 : _a.get_user_profile_attributes]);
    useEffect(function () {
        if (props.defaultFilters) {
            setFilters(__assign(__assign({}, filterValues), { status: localStorage.getItem(STATUS_FILTER_KEY) }), {});
        }
    }, [props.defaultFilters]);
    var renderUserFields = function (fields) {
        var allFields = fields.map(function (attr) {
            var _a, _b;
            var attrMappedName = convertToCamelCase(getAttributeLabel((_a = attr.name) !== null && _a !== void 0 ? _a : ""));
            if (((_b = attr.annotations) === null || _b === void 0 ? void 0 : _b.inputType) === "html5-date") {
                return (_jsx(FunctionField, { source: "applicant_data.".concat(attr.name), label: getTranslationLabel(attr.name, attr.display_name, t), render: function (record, source) {
                        return (_jsx(CustomDateField, { base: "applicant_data", source: "".concat(attrMappedName), label: getTranslationLabel(attr.name, attr.display_name, t), emptyText: "-" }, attr.name));
                    } }, attr.name));
            }
            else if (attr.multivalued) {
                return (_jsx(FunctionField, { source: "applicant_data.".concat(attrMappedName), label: getTranslationLabel(attr.name, attr.display_name, t), render: function (record) {
                        var value = record === null || record === void 0 ? void 0 : record.applicant_data[attrMappedName];
                        var values = value ? value.split(";") : [];
                        return (_jsx(_Fragment, { children: values ? (values.map(function (item, index) { return (_jsx(StyledChip, { label: item }, index)); })) : (_jsx(StyledNull, { children: "-" })) }));
                    } }, attr.name));
            }
            if (attr.name) {
                return (_jsx(FunctionField, { 
                    // source={`applicant_data[${attrMappedName}]` as any}
                    source: "applicant_data.".concat(attrMappedName), label: getTranslationLabel(attr.name, attr.display_name, t), render: function (record) {
                        var attributeValue = record === null || record === void 0 ? void 0 : record.applicant_data[attrMappedName];
                        if (attributeValue) {
                            return _jsx("span", { children: attributeValue });
                        }
                        return _jsx("span", { children: "-" });
                    } }, attr.name));
            }
            else {
                return null;
            }
        });
        return allFields;
    };
    var sx = {
        "@media (min-width: 960px)": {
            overflowX: "auto",
            width: "100%",
            maxWidth: isOpenSidebar ? "calc(100vw - 355px)" : "calc(100vw - 108px)",
        },
    };
    var restFields = useMemo(function () {
        var _a, _b;
        var theFields = [];
        theFields.push.apply(theFields, renderUserFields((_a = listFields === null || listFields === void 0 ? void 0 : listFields.basicInfoFields) !== null && _a !== void 0 ? _a : []));
        theFields.push.apply(theFields, renderUserFields((_b = listFields === null || listFields === void 0 ? void 0 : listFields.attributesFields) !== null && _b !== void 0 ? _b : []));
        localStorage.removeItem("RaStore.preferences.".concat(getPreferenceKey(location.pathname, "approvals"), ".datagrid.availableColumns"));
        return theFields;
    }, [listFields === null || listFields === void 0 ? void 0 : listFields.basicInfoFields, listFields === null || listFields === void 0 ? void 0 : listFields.attributesFields, location.pathname]);
    // Monitor and save filter changes
    useEffect(function () {
        if (filterValues === null || filterValues === void 0 ? void 0 : filterValues.status) {
            localStorage.setItem(STATUS_FILTER_KEY, filterValues.status);
        }
    }, [filterValues === null || filterValues === void 0 ? void 0 : filterValues.status]);
    return (_jsxs(DatagridConfigurable, __assign({ preferenceKey: getPreferenceKey(location.pathname, "approvals"), sx: sx }, props, { omit: listFields === null || listFields === void 0 ? void 0 : listFields.omitFields, bulkActionButtons: false, children: [_jsx(TextField, { source: "id" }), _jsx(DateField, { showTime: true, source: "created_at" }), _jsx(DateField, { showTime: true, source: "updated_at" }), _jsx(FunctionField, { source: "applicant_id", render: function (record) {
                    if (record.applicant_id && record.applicant_id !== "null") {
                        return record.applicant_id;
                    }
                    else {
                        return "-";
                    }
                } }), _jsx(TextField, { source: "verification_type" }), _jsx(FunctionField, { label: String(props.t("approvalsScreen.column.status")), render: function (record) { return (_jsx(StatusApplicationChip, { status: record.status.toUpperCase() })); } }), _jsx(TextField, { source: "annotations.verified_by", label: String(props.t("approvalsScreen.column.verified_by")), emptyText: "-" }), restFields, _jsx(ActionsColumn, { actions: props.actions, label: String(props.t("common.label.actions")) })] })));
};
var generateFilters = function (fields, t) {
    return fields.map(function (attr) {
        var _a, _b;
        // const source = `applicant_data[${convertToCamelCase(getAttributeLabel(attr.name ?? ""))}]`
        var source = "applicant_data.".concat(convertToCamelCase(getAttributeLabel((_a = attr.name) !== null && _a !== void 0 ? _a : "")));
        var label = getTranslationLabel(attr.name, attr.display_name, t);
        if (((_b = attr.annotations) === null || _b === void 0 ? void 0 : _b.inputType) === "html5-date") {
            return _jsx(TextInput, { source: source, label: label, type: "date" }, source);
        }
        else if (attr.multivalued) {
            return _jsx(TextInput, { source: source, label: label }, source);
        }
        return _jsx(TextInput, { source: "".concat(source, "._ilike"), label: label }, source);
    });
};
var CustomFilters = function (t, changeFilters, fields) {
    return __spreadArray([
        _jsx(SelectInput, { source: "status", label: String(t("approvalsScreen.column.status")), choices: [
                { id: "pending", name: "Pending" },
                { id: "accepted", name: "Accepted" },
                { id: "rejected", name: "Rejected" },
            ], defaultValue: localStorage.getItem(STATUS_FILTER_KEY), onChange: function (e) {
                if (e.target.value) {
                    localStorage.setItem(STATUS_FILTER_KEY, e.target.value);
                    changeFilters(e.target.value);
                }
            } }, "status_filter"),
        _jsx(SelectInput, { source: "verification_type", label: String(t("approvalsScreen.column.verificationType")), choices: [
                { id: "MANUAL", name: "Manual" },
                { id: "AUTOMATIC", name: "Automatic" },
            ] }, "verification_type_filter"),
        _jsx(TextInput, { source: "applicant_id", label: String(t("approvalsScreen.column.applicantId")) }, "applicant_id_filter"),
        _jsx(TextInput, { source: "id", label: String(t("approvalsScreen.column.id")) }, "id_filter")
    ], generateFilters(fields, t), true);
};
export var ListApprovals = function (_a) {
    var electionEventId = _a.electionEventId, electionId = _a.electionId, onViewApproval = _a.onViewApproval, electionEventRecord = _a.electionEventRecord;
    var t = useTranslation().t;
    var location = useLocation();
    var OMIT_FIELDS = [];
    var _b = useState(false), openExport = _b[0], setOpenExport = _b[1];
    var _c = useState(false), exporting = _c[0], setExporting = _c[1];
    var _d = useState(), exportDocumentId = _d[0], setExportDocumentId = _d[1];
    var notify = useNotify();
    var _e = useState(false), openImportDrawer = _e[0], setOpenImportDrawer = _e[1];
    var refresh = useRefresh();
    var _f = useWidgetStore(), addWidget = _f[0], setWidgetTaskId = _f[1], updateWidgetFail = _f[2];
    var exportApplication = useMutation(EXPORT_APPLICATION, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.APPLICATION_EXPORT,
            },
        },
    })[0];
    var importApplications = useMutation(IMPORT_APPLICATION, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.APPLICATION_IMPORT,
            },
        },
    })[0];
    // ✨ Admin Portal > Approvals: Add Approved By row #5050
    useEffect(function () {
        localStorage.removeItem("RaStore.preferences.".concat(getPreferenceKey(location.pathname, "approvals"), ".datagrid.availableColumns"));
    }, []);
    // Move the useGetOne hook here and handle the undefined case
    var election = useGetOne("sequent_backend_election", { id: electionId || "" }, { enabled: !!electionId } // Only fetch when electionId exists
    ).data;
    var handleExport = function () {
        setExporting(false);
        setExportDocumentId(undefined);
        setOpenExport(true);
    };
    var handleImport = function () {
        setOpenImportDrawer(true);
    };
    var handleImportApplications = function (documentId, sha256) { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, data, errors, task_id, err_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setOpenImportDrawer(false);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    currWidget = addWidget(ETasksExecution.IMPORT_APPLICATION, undefined);
                    return [4 /*yield*/, importApplications({
                            variables: {
                                tenantId: electionEventRecord === null || electionEventRecord === void 0 ? void 0 : electionEventRecord.tenant_id,
                                electionEventId: electionEventRecord === null || electionEventRecord === void 0 ? void 0 : electionEventRecord.id,
                                electionId: electionId,
                                documentId: documentId,
                                sha256: sha256,
                            },
                        })];
                case 2:
                    _a = _d.sent(), data = _a.data, errors = _a.errors;
                    task_id = (_c = (_b = data === null || data === void 0 ? void 0 : data.import_application) === null || _b === void 0 ? void 0 : _b.task_execution) === null || _c === void 0 ? void 0 : _c.id;
                    setWidgetTaskId(currWidget.identifier, task_id);
                    refresh();
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _d.sent();
                    console.log(err_1);
                    currWidget && updateWidgetFail(currWidget.identifier);
                    notify("application.import.messages.error", { type: "error" });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var confirmExportAction = function () { return __awaiter(void 0, void 0, void 0, function () {
        var currWidget, _a, exportApplicationData, errors, documentId, task_id, err_2;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!electionEventRecord) {
                        notify(t("approvalsScreen.export.error"));
                        setOpenExport(false);
                        return [2 /*return*/];
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    currWidget = addWidget(ETasksExecution.EXPORT_APPLICATION, undefined);
                    return [4 /*yield*/, exportApplication({
                            variables: {
                                tenantId: electionEventRecord.tenant_id,
                                electionEventId: electionEventRecord.id,
                                electionId: electionId,
                            },
                        })];
                case 2:
                    _a = _e.sent(), exportApplicationData = _a.data, errors = _a.errors;
                    setExporting(true);
                    if (errors || !exportApplicationData) {
                        setExporting(false);
                        updateWidgetFail(currWidget.identifier);
                        notify(t("approvalsScreen.export.error"));
                        return [2 /*return*/];
                    }
                    documentId = (_b = exportApplicationData.export_application) === null || _b === void 0 ? void 0 : _b.document_id;
                    task_id = (_d = (_c = exportApplicationData === null || exportApplicationData === void 0 ? void 0 : exportApplicationData.export_application) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                    setExportDocumentId(documentId);
                    task_id
                        ? setWidgetTaskId(currWidget.identifier, task_id)
                        : updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 3:
                    err_2 = _e.sent();
                    setExporting(false);
                    currWidget && updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var actions = [
        {
            icon: _jsx(Visibility, {}),
            action: onViewApproval,
        },
    ];
    var tenantId = useTenantStore()[0];
    var _g = useQuery(USER_PROFILE_ATTRIBUTES, {
        variables: {
            tenantId: tenantId,
            electionEventId: electionEventId,
        },
    }), userAttributes = _g.data, userAttributesLoading = _g.loading;
    // Get initial status from localStorage or use "pending" as default
    // const defaultFilters = localStorage.getItem(STATUS_FILTER_KEY) // || "pending"
    var _h = useState(localStorage.getItem(STATUS_FILTER_KEY) || "pending"), defaultFilters = _h[0], setDefaultFilters = _h[1];
    var listFilter = useMemo(function () {
        var filter = {
            election_event_id: electionEventId || undefined,
        };
        if (election === null || election === void 0 ? void 0 : election.permission_label) {
            filter.permission_label = election.permission_label;
        }
        return filter;
    }, [electionEventId, election === null || election === void 0 ? void 0 : election.permission_label, defaultFilters]);
    var authContext = useContext(AuthContext);
    var canExport = authContext.isAuthorized(true, tenantId, IPermissions.APPLICATION_EXPORT);
    var canImport = authContext.isAuthorized(true, tenantId, IPermissions.APPLICATION_IMPORT);
    // add election level
    if (userAttributesLoading) {
        return null;
    }
    if (!electionEventRecord) {
        return _jsx(CircularProgress, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(List, { actions: _jsx(ListActions, { preferenceKey: getPreferenceKey(location.pathname, "approvals"), withImport: canImport, withExport: canExport, doImport: handleImport, doExport: handleExport }), 
                // empty={false}
                resource: "sequent_backend_applications", filters: CustomFilters(t, setDefaultFilters, (userAttributes === null || userAttributes === void 0 ? void 0 : userAttributes.get_user_profile_attributes) || []), filter: listFilter, sort: { field: "created_at", order: "DESC" }, perPage: 10, filterDefaultValues: { status: defaultFilters }, disableSyncWithLocation: true, children: _jsx(ApprovalsList, { omit: OMIT_FIELDS, actions: actions, t: t, userAttributes: userAttributes, defaultFilters: defaultFilters }) }), _jsx(Dialog, { variant: "info", open: openExport, ok: String(t("application.export.button")), okEnabled: function () { return !exporting; }, cancel: String(t("common.label.cancel")), title: String(t("application.export.title")), handleClose: function (result) {
                    if (result) {
                        confirmExportAction();
                        setExporting(false);
                        setOpenExport(false);
                    }
                    else {
                        setExportDocumentId(undefined);
                        setExporting(false);
                        setOpenExport(false);
                    }
                }, children: t("common.export") }), _jsx(FormStyles.ReservedProgressSpace, { children: exporting && exportDocumentId ? (_jsx(DownloadDocument, { documentId: exportDocumentId, electionEventId: (electionEventRecord === null || electionEventRecord === void 0 ? void 0 : electionEventRecord.id) || "", fileName: "export-applications.csv", onDownload: function () {
                        setExportDocumentId(undefined);
                        setExporting(false);
                        setOpenExport(false);
                        notify(t("approvalsScreen.export.success"), {
                            type: "success",
                        });
                    } })) : null }), _jsx(ImportDataDrawer, { open: openImportDrawer, closeDrawer: function () { return setOpenImportDrawer(false); }, title: "application.import.title", subtitle: "application.import.subtitle", paragraph: "application.import.paragraph", doImport: handleImportApplications, errors: null })] }));
};
var templateObject_1, templateObject_2;
